module.exports = __webpack_public_path__ + "static/media/img10.06314100.jpeg";